// extracted by mini-css-extract-plugin
export var growableInput = "_3b-0";
export var tagContainer = "_3b-2";
export var textInput = "_3b-1";